import { BlockEditProps } from "@wordpress/blocks";
import React, { useCallback } from "react";
import type { BlockAttributes } from "./block.json";
import {
  InspectorControls,
  RichText,
  useBlockProps,
  useInnerBlocksProps,
} from "@wordpress/block-editor";
import "../slider/swiper";
import parse from "html-react-parser";
import ImageEditor from "../../../source/components/ImageEditor";
import {
  useEntityProp,
  useEntityRecord,
  useEntityRecords,
} from "@wordpress/core-data";

function ProfileCard({
  profile,
}: {
  profile: {
    id: number;
    title: { rendered: string };
    featured_media: number;
    meta: { position: string; first_name: string; last_name: string };
  };
}) {
  // Fetch the featured image (thumbnail) using the featured_media ID
  const thumbnail = useEntityRecord<{
    source_url: string;
    title: { rendered: string };
  }>("postType", "attachment", String(profile.featured_media))?.record;

  return (
    <div className="profile profile-leitung">
      <div className="img-wrapper">
        {thumbnail?.source_url && (
          <img
            className="w-100"
            src={thumbnail.source_url}
            alt={thumbnail?.title.rendered || profile.title.rendered}
          />
        )}
      </div>

      <div className="ps-2 ps-lg-0 pe-3">
        <h3 className="pt-4 pt-lg-5 mb-0 text-uppercase">
          {parse(profile.meta.first_name)}
        </h3>
        <h3 className="mb-2 text-uppercase">{parse(profile.meta.last_name)}</h3>
        <p className="copy-s role">{parse(profile.meta.position || "")}</p>
      </div>
    </div>
  );
}

function ProfileListEditorPreview() {
  const profiles = useEntityRecords<{
    id: number;
    title: { rendered: string };
    featured_media: number;
    meta: { position: string; first_name: string; last_name: string };
  }>("postType", "leitung", {
    status: "publish",
    per_page: -1,
    orderby: "date",
    order: "asc",
  }).records;

  if (!profiles || profiles.length === 0) {
    return (
      <div className="text-center" style={{ opacity: 0.8 }}>
        <strong className="d-block">Leitung</strong>
        Keine Leitung gefunden. Bitte erstellen Sie zuerst Leitungprofile.
      </div>
    );
  }

  return (
    <>
      <div className="grid-container">
        {profiles.map((profile) => (
          <div key={profile.id} className="">
            <ProfileCard profile={profile} />
          </div>
        ))}
      </div>
    </>
  );
}
export default function ProfileEditor(
  props: BlockEditProps<BlockAttributes>
): JSX.Element {
  const blockProps = useBlockProps({ className: "profiles-list" });

  return (
    <>
      <div {...blockProps}>
        <ProfileListEditorPreview />
      </div>
    </>
  );
}
